export class SelectThemePage
{
	private readonly _changeEventName = "change";
	private readonly _disabledButtonCssClass = "btn-outline-purple";
	private readonly _enabledButtonCssClass = "btn-purple";
	private readonly _submitButtonSelector = ".js-theme-submit";
	private readonly _themeCheckedSelector = "input[name='SelectorCollectionId']:checked ";
	private readonly _themeSelector = "input[name='SelectorCollectionId'] ";

	constructor()
	{
		this.Initialize();
	}

	public async Initialize(): Promise<void>
	{
		const sizeLists = document.querySelectorAll(this._themeSelector);

		sizeLists.forEach(item =>
		{
			item.addEventListener(this._changeEventName, () =>
			{
				this.HandleThemeSelected();
			});
		});

		this.HandleThemeSelected();
	}

	private HandleThemeSelected(): void
	{
		const btnSubmit = document.querySelector(this._submitButtonSelector) as HTMLInputElement;
		const checked = document.querySelector(this._themeCheckedSelector);

		if (checked != null)
		{
			btnSubmit.disabled = false;
			btnSubmit.classList.add(this._enabledButtonCssClass);
			btnSubmit.classList.remove(this._disabledButtonCssClass);
		}
		else
		{
			btnSubmit.disabled = true;
			btnSubmit.classList.remove(this._enabledButtonCssClass);
			btnSubmit.classList.add(this._disabledButtonCssClass);
		}
	}
}